import { LOGOUT_REQUEST, LoginResponse, setCompanyForSessionStorage } from '@sit/client-shared';
import { Reducer, handleActions } from 'redux-actions';

import * as types from './types';

const initialState = {
  data: {},
  error: null,
  loading: false,
  saving: false,
  token: null,
};

const getUserRequest = (state: any) => ({
  ...state,
  error: null,
  loading: true,
});
const getUserRequestFailure = (state: any, action: any) => ({
  ...state,
  error: action.error,
  loading: false,
  token: null,
});
const getUserRequestSuccess = (state: any, payload: any) => ({
  ...state,
  data: payload.data,
  error: null,
  loading: false,
});

const loginRequest = (state: any) => ({
  ...state,
  data: {
    ...state.data,
  },
  error: null,
  loading: true,
});
const loginRequestFailure = (state: any, action: any) => ({
  ...state,
  data: {
    ...state.data,
  },
  error: action.error,
  loading: false,
});
const loginRequestSuccess: Reducer<any, LoginResponse> = (state, { payload: { token, refreshToken, user } }) => {
  setCompanyForSessionStorage(user.defaultCompanyId);
  return {
    ...state,
    data: { ...user },
    error: null,
    loading: false,
    token,
    refreshToken,
  };
};

const logoutRequest = () => initialState;

const registerResetEmailRequest = (state: any) => ({
  ...state,
  error: null,
  loading: true,
});
const registerResetEmailRequestFailure = (state: any, action: any) => ({
  ...state,
  error: action.error,
  loading: false,
  token: null,
});
const registerResetEmailRequestSuccess = (state: any, payload: any) => ({
  ...state,
  error: null,
  loading: false,
  token: null,
});

const registerEmployeeRequest = (state: any) => ({
  ...state,
  error: null,
  loading: true,
});
const registerEmployeeRequestFailure = (state: any, action: any) => ({
  ...state,
  error: action.error,
  loading: false,
  token: null,
});
const registerEmployeeRequestSuccess = loginRequestSuccess;

const sendFallbackMfaRequest = (state: any) => ({
  ...state,
  error: null,
  loading: true,
});
const sendFallbackMfaRequestFailure = (state: any, action: any) => ({
  ...state,
  error: action.error,
  loading: false,
});
const sendFallbackMfaRequestSuccess = (state: any, payload: any) => ({
  ...state,
  error: null,
  loading: false,
});

const updateUserRequest = (state: any) => ({
  ...state,
  error: null,
  saving: true,
});
const updateUserRequestFailure = (state: any, action: any) => ({
  ...state,
  error: action.error,
  saving: false,
});
const updateUserRequestSuccess = (state: any, payload: any) => ({
  ...state,
  data: { ...payload.data },
  error: null,
  saving: false,
});

const updateAccessToken = (state: any, payload: any) => ({
  ...state,
  token: payload.data.token,
});

const updatePasswordRequest = (state: any) => ({
  ...state,
  error: null,
  loading: false,
  saving: true,
});
const updatePasswordRequestFailure = (state: any, action: any) => ({
  ...state,
  error: action.error,
  loading: false,
  saving: false,
});
const updatePasswordRequestSuccess = (state: any, payload: any) => ({
  ...state,
  error: null,
  loading: false,
  saving: false,
});

export default handleActions(
  {
    [types.GET_USER_REQUEST]: getUserRequest,
    [types.GET_USER_REQUEST_FAILURE]: getUserRequestFailure,
    [types.GET_USER_REQUEST_SUCCESS]: getUserRequestSuccess,
    [types.LOGIN_REQUEST]: loginRequest,
    [types.LOGIN_REQUEST_FAILURE]: loginRequestFailure,
    [types.LOGIN_REQUEST_SUCCESS]: loginRequestSuccess,
    [LOGOUT_REQUEST]: logoutRequest,
    [types.REGISTER_RESEND_EMAIL_REQUEST]: registerResetEmailRequest,
    [types.REGISTER_RESEND_EMAIL_REQUEST_FAILURE]: registerResetEmailRequestFailure,
    [types.REGISTER_RESEND_EMAIL_REQUEST_SUCCESS]: registerResetEmailRequestSuccess,
    [types.REGISTER_EMPLOYEE_REQUEST]: registerEmployeeRequest,
    [types.REGISTER_EMPLOYEE_REQUEST_FAILURE]: registerEmployeeRequestFailure,
    [types.REGISTER_EMPLOYEE_REQUEST_SUCCESS]: registerEmployeeRequestSuccess,
    [types.SEND_FALLBACK_MFA_CODE_REQUEST]: sendFallbackMfaRequest,
    [types.SEND_FALLBACK_MFA_CODE_REQUEST_FAILURE]: sendFallbackMfaRequestFailure,
    [types.SEND_FALLBACK_MFA_CODE_REQUEST_SUCCESS]: sendFallbackMfaRequestSuccess,
    [types.UPDATE_ACCESS_TOKEN]: updateAccessToken,
    [types.UPDATE_PASSWORD_REQUEST]: updatePasswordRequest,
    [types.UPDATE_PASSWORD_REQUEST_FAILURE]: updatePasswordRequestFailure,
    [types.UPDATE_PASSWORD_REQUEST_SUCCESS]: updatePasswordRequestSuccess,
    [types.UPDATE_USER_REQUEST]: updateUserRequest,
    [types.UPDATE_USER_REQUEST_FAILURE]: updateUserRequestFailure,
    [types.UPDATE_USER_REQUEST_SUCCESS]: updateUserRequestSuccess,
  },
  initialState,
);
